import React from 'react'
import {Outlet, Navigate} from 'react-router-dom'

const AuthRoute = ({children, auth}: any) => {
  console.log(auth.role)
  return auth.role === 0 ? children : <Navigate to={'/admin/auth'} replace/>
}

export default AuthRoute
